import React from 'react';

const ButtonSendChatMessage = ({ children, disabled = false, onClick }) => {
    const classes = ['appButton__sendChatMessage'];

    return(
        <button type="button" className={classes.join(' ')} disabled={disabled} onClick={onClick}>
            {children}
        </button>
    )
}

export default ButtonSendChatMessage;